import { useState, useCallback, useEffect } from 'react';
import { toast } from 'sonner';
import { monthlyConsumptionApi, TeamHoursStatistic } from '@/lib/api/monthly-consumption';

interface UseTeamHoursStatisticsParams {
  contractId?: string;
  companyId?: string;
  month?: number;
  year?: number;
}

export const useTeamHoursStatistics = (params?: UseTeamHoursStatisticsParams) => {
  const [teamStats, setTeamStats] = useState<TeamHoursStatistic[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTeamStats = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await monthlyConsumptionApi.getTeamHoursStatistics(params);
      setTeamStats(data);
      return data;
    } catch (err: any) {
      toast.error(err.response?.data?.message || 'Failed to load team hours statistics');
      return [];
    } finally {
      setIsLoading(false);
    }
  }, [params?.contractId, params?.companyId, params?.month, params?.year]);

  useEffect(() => {
    fetchTeamStats();
  }, [fetchTeamStats]);

  return {
    teamStats,
    isLoading,
    refreshTeamStats: fetchTeamStats,
  };
};
